import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import ArrowBackIosOutlinedIcon from '@mui/icons-material/ArrowBackIosOutlined';
import IndividualQR from './IndividualQR';
import BulkQR from './BulkQR';
import classes from "../QrDetails/style.module.scss"
import RadioButton from '../../../../component/RadioButton';
import { Images } from '../../../../assets';
import Button from '../../../../component/Button';
import { FormProvider, useForm } from "react-hook-form";
import SuccessModal from '../../../../modalComponents/SuccessModal';
import Exported from '../../../../service/endpoints';
import request from '../../../../service';
import { Toast } from '../../../../service/toast';
import { saveLoadingState } from '../../../../redux/reducers/loadingSlice';
import { useDispatch } from 'react-redux';



const GenerateQrcode = ({ activeTab }) => {

    const formMethods = useForm({
        mode: 'onSubmit',
    });
    const {
        handleSubmit,
        control,
        formState: { errors },
        clearErrors,
        register,
        getValues,
        trigger,
    } = formMethods;

    const [fileName, setFileName] = useState(null);
    const [isFileUploading, setIsFileUploading] = useState(false);
    const [uploadedFiles, setUploadedFiles] = useState(null);
    const [filteredProduct, setFilteredProduct] = useState([]);
    const [radioValue, setRadioValue] = useState(activeTab === 'Bulk' ? 'Bulk QR' : 'Individual QR');
    const [isSuccess, setIsSuccess] = useState(false)
    const [successMessage, setSuccessMessage] = useState(null)
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const radioOptions = [
        { value: 'Individual QR', label: 'Individual QR' },
        { value: 'Bulk QR', label: 'Bulk QR' },
    ];

    const handleRadioChange = (event) => {
        setRadioValue(event.target.value);
        clearErrors()
    };

    const individualUpload = async () => {
        const formData = new FormData();
        formData.append('file', uploadedFiles[0])


        await request({
            url: Exported.Endpoints.individualUploadQR,
            method: Exported.APIMethods.POST,
            data: formData,
            headers: {
                'content-type': 'multipart/form-data',
            },
        }).then((res) => {
            if (res?.data?.status) {
                setIsSuccess(true)
            }
        }).catch((err) => {
            console.log(err, "err")
            Toast({
                type: 'error',
                message: 'Unable to process the request!..'
            })
        })
    }

    const bulkUpload = async () => {
        const formData = new FormData();
        formData.append('file', uploadedFiles[0])


        await request({
            url: Exported.Endpoints.bulkUploadQR,
            method: Exported.APIMethods.POST,
            data: formData,
            headers: {
                'content-type': 'multipart/form-data',
            },
        }).then((res) => {
            if (res?.data?.status) {
                setIsSuccess(true)
            }
        }).catch((err) => {
            console.log(err, "err")
            Toast({
                type: 'error',
                message: 'Unable to process the request!..'
            })
        })
    }

    const onSubmit = async (data) => {
        
        if (uploadedFiles && uploadedFiles.length > 0) {
            trigger();
            dispatch(saveLoadingState(true))
            radioValue === 'Individual QR' ? await individualUpload() : await bulkUpload()
        }
        else {
            trigger();
            dispatch(saveLoadingState(true))
            let qrData = filteredProduct?.map((it, idx) => {
                const item = {
                    productId: it.id,
                    quantity: parseInt(data?.item[idx]?.inputValue),
                };

                if (radioValue !== 'Individual QR') {
                    item.cartonQuantity = parseInt(data?.item[idx]?.quantity);
                }

                return item;
            });
            const requestData = {
                "qrData": qrData
            }
            await request({
                url: radioValue === 'Individual QR' ? Exported.Endpoints.sendIndividualQR : Exported.Endpoints.sendBulkQR,
                method: Exported.APIMethods.POST,
                data: requestData
            }).then((res) => {
                if (res?.data?.status) {
                    setIsSuccess(true)
                } else if(res?.data?.message) {
                    setSuccessMessage(res?.data?.message)
                    setIsSuccess(true)
                }
            }).catch((err) => {
                console.log(err, "err")
                Toast({
                    type: 'error',
                    message: 'Unable to process the request!..'
                })
            })
        }
        dispatch(saveLoadingState(false))
    };

    const redirectBack = () => {
        navigate('')
    };

    const handleCloseSuccess = () => {
        setIsSuccess(false)
        setSuccessMessage(null)
        setFilteredProduct([])
        redirectBack()
    }


    return (
        <div>
            <div className={`w-[100%] flex items-center justify-between`}>
                <div className={`layout-title flex items-center`}>
                    <div className='mr-2 flex items-center cursor-pointer' onClick={() => redirectBack()}>
                        <ArrowBackIosOutlinedIcon />
                    </div>
                    <div>Generate QR Code</div>
                </div>
            </div>
            <div className={`mt-5 ${classes.qrCardWrapper}`}>
                <RadioButton
                    radioValue={radioValue}
                    onChange={handleRadioChange}
                    options={radioOptions}
                />
            </div>
            <FormProvider {...formMethods}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <IndividualQR formMethods={formMethods} errors={errors} required={fileName?.length > 0 ? true : false}
                        fileName={fileName} setFileName={setFileName} isFileUploading={isFileUploading} setIsFileUploading={setIsFileUploading} files={uploadedFiles} setFiles={setUploadedFiles} />
                    <img src={Images.breakLine} className='my-6' />
                    <BulkQR formMethods={formMethods} errors={errors} control={control} required={fileName?.length > 0 ? false : true} radioValue={radioValue}
                        filteredProduct={filteredProduct} setFilteredProduct={setFilteredProduct} />
                    <div className='flex gap-4 justify-end mb-6'>
                        <Button text="Cancel" style={{ width: "160px", backgroundColor: 'transparent', color: '#1F2155', height: "40px", fontSize: "16px" }} onClick={() => redirectBack()} />
                        <Button text="Generate" style={{ width: "170px", height: "40px", fontSize: "16px" }} />
                    </div>
                </form>
            </FormProvider>

            {isSuccess &&
                <SuccessModal
                    isOpen={isSuccess}
                    closePopUp={handleCloseSuccess}
                    successText={'QR Code generated!'}
                    // modalText={successMessage || 'Please check after sometime.'}
                />
            }
        </div >
    )
}

export default GenerateQrcode